import {
  AvatarModule,
  BadgeModule,
  BreadcrumbModule,
  ButtonGroupModule,
  ButtonModule,
  CardModule,
  DropdownModule,
  FooterModule,
  FormModule,
  GridModule,
  HeaderModule,
  ListGroupModule,
  NavModule,
  ProgressModule,
  SharedModule,
  SidebarModule,
  SpinnerModule,
  TabsModule,
  UtilitiesModule,
} from '@coreui/angular';
import { BrowserModule, Title } from '@angular/platform-browser';
import {
  DefaultFooterComponent,
  DefaultHeaderComponent,
  DefaultLayoutComponent,
} from './containers';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HashLocationStrategy, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { IconModule, IconSetService } from '@coreui/icons-angular';
import {
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarConfigInterface,
  PerfectScrollbarModule,
} from 'ngx-perfect-scrollbar';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsModalService } from 'ngx-bootstrap/modal'
import { CheckInDetailComponent } from './dialogs/check-in-detail/check-in-detail.component';
import { CheckInsPerPetDetailComponent } from './dialogs/check-ins-per-pet-detail/check-ins-per-pet-detail.component';
import { CheckInsPerPetDetailModule } from './dialogs/check-ins-per-pet-detail/check-ins-per-pet-detail.module';
import { CheckOutDetailComponent } from './dialogs/check-out-detail/check-out-detail.component';
import { DataMappingService } from './services/data-mapping.service';
import { DatePipe } from '@angular/common';
import { ExpenseDetailComponent } from './dialogs/expense-detail/expense-detail.component';
import { ExpenseDetailModule } from './dialogs/expense-detail/expense-detail.module';
import { JsonDataService } from './services/json-data.service';
import { LanguageDropdownComponent } from './views/language-dropdown/language-dropdown.component';
import { LanguageDropdownModule } from './views/language-dropdown/language-dropdown.module';
import { LanguageService } from './services/language.service';
import { ModalModule } from '@coreui/angular';
import { MonthlyExpensesPerItemComponent } from './dialogs/monthly-expenses-per-item/monthly-expenses-per-item.component';
import { MonthlyExpensesPerItemModule } from './dialogs/monthly-expenses-per-item/monthly-expenses-per-item.module';
import { MonthlyRevenuesPerItemComponent } from './dialogs/monthly-revenues-per-item/monthly-revenues-per-item.component';
import { MonthlyRevenuesPerItemModule } from './dialogs/monthly-revenues-per-item/monthly-revenues-per-item.module';
import { NgModule } from '@angular/core';
import { NgxPaginationModule } from 'ngx-pagination';
import { OwnerDetailComponent } from './dialogs/owner-detail/owner-detail.component';
import { OwnerDetailModule } from './dialogs/owner-detail/owner-detail.module';
import { PetDetailComponent } from './dialogs/pet-detail/pet-detail.component';
import { PetService } from './services/pet.service';
import { PickUpDetailComponent } from './dialogs/pick-up-detail/pick-up-detail.component';
import { RegistrationPetDetailDialogComponent } from './dialogs/registration-pet-detail-dialog/registration-pet-detail-dialog.component';
import { ReportsModule } from './views/reports/reports.module';
import { SuccessDialogComponent } from './dialogs/success-dialog/success-dialog.component';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { ToastrModule } from 'ngx-toastr';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { UserDetailComponent } from './dialogs/user-detail/user-detail.component';
import { UserDetailModule } from './dialogs/user-detail/user-detail.module';
import { UserSignupComponent } from './dialogs/user-signup/user-signup.component';
import { UserSignupModule } from './dialogs/user-signup/user-signup.module';
import { QRCodeDetailComponent } from './dialogs/qr-code-detail/qr-code-detail.component';
import { QRCodeDetailModule } from './dialogs/qr-code-detail/qr-code-detail.module';
import { QRCodeModule } from 'angularx-qrcode';
import { NgxEditorModule } from 'ngx-editor';
// import { PaginationModule } from 'ngx-bootstrap/pagination';



// import { ModalModule } from "ngx-bootstrap/modal";










// import { PetDetailComponent } from './dialogs/Pet-detail/Pet-detail.component';





// Import containers






// Import app component

// Import routing module

// export function HttpLoaderFactory(http: HttpClient) {
//   return new TranslateHttpLoader(http, './assets/i18n/', '.json');
// }

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}



const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

const APP_CONTAINERS = [
  DefaultFooterComponent,
  DefaultHeaderComponent,
  DefaultLayoutComponent,
];

@NgModule({
  declarations: [AppComponent, ...APP_CONTAINERS, PetDetailComponent, OwnerDetailComponent, CheckInDetailComponent,
    CheckOutDetailComponent, SuccessDialogComponent, LanguageDropdownComponent, RegistrationPetDetailDialogComponent, ExpenseDetailComponent,
    PickUpDetailComponent, UserDetailComponent, UserSignupComponent, CheckInsPerPetDetailComponent, MonthlyRevenuesPerItemComponent, MonthlyExpensesPerItemComponent,
    QRCodeDetailComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    BsDatepickerModule.forRoot(),
    AppRoutingModule,
    AvatarModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
    }),
    BreadcrumbModule,
    FooterModule,
    DropdownModule,
    GridModule,
    HeaderModule,
    SidebarModule,
    IconModule,
    PerfectScrollbarModule,
    NavModule,
    ButtonModule,
    FormModule,
    UtilitiesModule,
    ButtonGroupModule,
    ReactiveFormsModule,
    SidebarModule,
    SharedModule,
    TabsModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    ListGroupModule,
    ProgressModule,
    DatePipe,
    BadgeModule,
    ListGroupModule,
    CardModule,
    ModalModule,
    SpinnerModule,
    TypeaheadModule.forRoot(),
    TimepickerModule.forRoot(),
    // PaginationModule,
    NgxPaginationModule,
    OwnerDetailModule,
    UserDetailModule,
    UserSignupModule,
    LanguageDropdownModule,
    CheckInsPerPetDetailModule,
    ExpenseDetailModule,
    MonthlyRevenuesPerItemModule,
    MonthlyExpensesPerItemModule,
    QRCodeDetailModule,
    QRCodeModule,
    NgxEditorModule,
    // ReportsModule,
  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    DatePipe,
    BsModalService,
    IconSetService,
    Title,
    PetService,
    JsonDataService,
    LanguageService,
    DataMappingService,
  ],
  // exports: [ ModalModule ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
